import PaymentDetails from "./PaymentDetails";

import "@styles/base/pages/app-ecommerce-details.scss";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";
import { ArrowLeft, Upload, FileText, Edit, ArrowRight } from "react-feather";
import classnames from "classnames";
import { useEffect } from "react";
import { getCourseDetail } from "../action";

const Payment = (props) => {
  const {
    data,
    payment,
    transactionCourseUser,
    transactionPaymentProofs,
    getCourseDetail,
    courseId,
    transactionCourseUserId,
    dispatch,
    stepper,
  } = props;

  const printLink =
    "/receipt/" +
    (transactionCourseUser && transactionCourseUser.courseId
      ? transactionCourseUser.courseId
      : "") +
    "/" +
    (transactionCourseUser && transactionCourseUser.userId
      ? transactionCourseUser.userId
      : "") +
    "?newAdd=No";

  const printLinkNewAddress =
    "/receipt/" +
    (transactionCourseUser && transactionCourseUser.courseId
      ? transactionCourseUser.courseId
      : "") +
    "/" +
    (transactionCourseUser && transactionCourseUser.userId
      ? transactionCourseUser.userId
      : "") +
    "?newAdd=Yes";

  return (
    <div>
      {Object.keys(data).length ? (
        <PaymentDetails
          payment={payment}
          dispatch={dispatch}
          courseId={courseId}
          getCourseDetail={getCourseDetail}
          data={data}
          transactionCourseUser={transactionCourseUser}
          transactionPaymentProofs={transactionPaymentProofs}
        />
      ) : null}

      <Link
        className="btn-wishlist mr-0 mr-sm-1 mb-1 mb-sm-0 btn btn-outline-primary"
        outline
        to="/payment"
      >
        <ArrowLeft size={14} className={classnames("mr-50")} />
        <span>กลับ</span>
      </Link>
      {transactionCourseUser &&
      transactionCourseUser.status === "WAIT_PAYMENT" ? (
        <Button
          color="primary"
          className="btn-wishlist mr-0 mr-sm-1 mb-1 mb-sm-0"
          onClick={() => stepper.next()}
        >
          <Upload className="mr-50" size={14} />
          Upload หลักฐานยืนยันการชำระเงิน
        </Button>
      ) : null}
      {transactionCourseUser &&
      (transactionCourseUser.status === "PAYMENT_SUCCESS" ||
        transactionCourseUser.status === "WAIT_ADMIN_APPROVE") ? (
        <Button
          color="primary"
          className="btn-wishlist mr-0 mr-sm-1 mb-1 mb-sm-0"
          onClick={() => stepper.next()}
        >
          หลักฐานการชำระเงิน{" "}
          <ArrowRight size={14} className={classnames("mr-50")} />
        </Button>
      ) : null}
    </div>
  );
};

export default Payment;
